export enum InputEnum {
  input = 'input',
  maxHeight = '100%',
  maxWidth = '100%',
  keypress = 'keypress',
  blur = 'blur',
}
